import { sizeToPixelString, spacingToPixelString } from '@topcon/tuicl/dist/common/utils';
import styled from 'styled-components';
import { CSSProperties } from 'react';
import { SpacingProperty } from '@topcon/tuicl';

import { background, border } from '../providers/theme/theme.index';

export const Section = styled.div<{
  $alignment?: string;
  $padding?: string;
  /** `s` caps at 768px, `full` removes the cap; default caps at 1280px. */
  $width?: 's' | 'full';
  $background?: string;
  $direction?: string;
  $gap?: string;
  $height?: string;
  $borderRadius?: string;
}>`
  display: flex;
  flex-direction: ${(props) => props.$direction ?? 'column'};
  align-items: ${(props) => props.$alignment || 'initial'};
  ${(props) => props.$gap && `gap: ${sizeToPixelString(props.$gap)};`}
  width: 100%;
  height: ${(props) => props.$height || 'fit-content'};
  max-width: ${(props) =>
    props.$width === 's' ? '768px' : props.$width === 'full' ? 'none' : '1280px'};
  background: ${(props) => props.$background || background.primary};

  padding: ${(props) => props.$padding};
  border-radius: ${(props) => props.$borderRadius};

  box-sizing: border-box;
`;

export const FlexWrapper = styled.div<{
  $alignment?: CSSProperties['alignItems'];
  $justify?: CSSProperties['justifyContent'];
  $width?: CSSProperties['width'];
  $height?: CSSProperties['height'];
  $gap?: SpacingProperty;
  $padding?: SpacingProperty;
  $background?: string;
  $grow?: CSSProperties['flexGrow'];
}>`
  display: flex;
  width: ${(props) => props.$width || '100%'};
  height: ${(props) => props.$height || 'fit-content'};
  align-items: ${(props) => props.$alignment || 'center'};
  justify-content: ${(props) => props.$justify || 'flex-start'};
  background: ${(props) => props.$background || background.tertiary};
  padding: ${(props) => spacingToPixelString(props.$padding ?? 'xs')};
  gap: ${(props) => spacingToPixelString(props.$gap ?? 'xs')};
  flex: ${(props) => props.$grow ?? '0'};

  box-sizing: border-box;
`;

export const PageWrapper = styled.div`
  display: flex;
  flex: 0 1 auto;
  width: 100%;
  max-width: 784px;
  overflow: hidden;
`;

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  border: 1px solid ${border.primary};
`;
